// extracted by mini-css-extract-plugin
export var box = "_5w-0";
export var check = "_5w-1";
export var checkboxButton = "_5w-6";
export var checkboxGroup = "_5w-5";
export var disabled = "_5w-7";
export var ghost = "_5w-9";
export var input = "_5w-2";
export var label = "_5w-4";
export var normal = "_5w-8";
export var uncheck = "_5w-3";